import { REGION } from '../../../pure-js/libs/Consts'

/**
 * Get the base URL for Firebase Cloud Functions
 * Returns local emulator URL in development, production URL otherwise
 */
export const getFunctionsBaseUrl = (): string => {
  const isLocal = import.meta.env.VITE_FUNCTIONS_LOCAL === 'true'
  const emulatorHost = import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST || window.location.hostname || 'localhost'

  if (isLocal) {
    // Local emulator (must run "yarn serve" in functions folder)
    return `http://${emulatorHost}:5001/courseportal-fb83a/europe-west3`
  }

  // Production
  return `https://${REGION}-courseportal-fb83a.cloudfunctions.net`
}

/**
 * Build a full URL for a specific Cloud Function
 */
export const getFunctionUrl = (functionName: string): string => {
  return `${getFunctionsBaseUrl()}/${functionName}`
}
